<rask-fieldset-toggle
    [formGroup]="form"
    label="Transportföretag"
    [defaultExpanded]="open"
    [nrOfSelectedFilters]="filterLength">
    <rask-multi-selector
        label="Transportföretag"
        bindValue="key"
        bindLabel="value"
        class="w-100"
        [items]="options.values$"
        formControlName="transportforetag"
        [selected]="control.value"
        [portalToBody]="true"
        [searchFn]=keyValueSearchFn>
    </rask-multi-selector>
</rask-fieldset-toggle>